export const breakpoints = {
  xs: 280,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  MAX_MOBILE_WIDTH: 1024,
  MENU_CLOSE_WIDTH: 1440
}

// export const devices = {
//   xs: `(min-width: ${breakpoints.xs}px)`,
//   sm: `(min-width: ${breakpoints.sm}px)`,
//   md: `(min-width: ${breakpoints.md}px)`,
//   lg: `(min-width: ${breakpoints.lg}px)`,
//   xl: `(min-width: ${breakpoints.xl}px)`,
//   '2xl': `(min-width: ${breakpoints['2xl']}px)`
// }
